__turbopack_context__.v({
  "homeLocation": "S5CBsW_homeLocation",
});
